import { useQuery } from '@tanstack/react-query'
import { useState, useEffect } from 'react'
import { apiClient } from '@/shared/api/client'

interface GiftCardStatusData {
  status: string
  code?: string
  initialAmount: number
  currency: string
  expiresAt: string | null
  recipientEmail: string | null
}

interface GiftCardStatusResponse {
  success: boolean
  data: GiftCardStatusData
}

export function useGiftCardStatus(giftCardId: string | null) {
  const [pollCount, setPollCount] = useState(0)
  const maxPolls = 24 // 60 seconds (24 × 2.5s)

  const query = useQuery({
    queryKey: ['gift-card-status', giftCardId],
    queryFn: async () => {
      setPollCount((c) => c + 1)
      const response = await apiClient<GiftCardStatusResponse>(
        `/api/public/gift-cards/${giftCardId}/payment-status`
      )
      return response.data
    },
    enabled: !!giftCardId,
    refetchInterval: (q) => {
      const data = q.state.data
      if (data?.status === 'pending' && pollCount < maxPolls) return 2500
      return false
    },
  })

  return { ...query, pollCount, maxPolls }
}
